<div class="visitor-registration-summary">
  <sc-title>
    <sc-dictionary-label
      dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.title"></sc-dictionary-label>
  </sc-title>

  <p *ngIf="isUsingSmartphone">
    <sc-dictionary-label
      dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.description"></sc-dictionary-label>
  </p>

  <mat-card>
    <table>
      <tr>
        <td class="label"><label>
            <sc-dictionary-label
              dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.numberPlate"></sc-dictionary-label>:</label>
        </td>
        <td class="bold">{{numberPlate}}</td>
      </tr>
      <tr>
        <td class="label"><label>
            <sc-dictionary-label
              dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.company"></sc-dictionary-label>:</label>
        </td>
        <td class="bold">{{company}}</td>
      </tr>
      <tr>
        <td class="label"><label>
            <sc-dictionary-label
              dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.name"></sc-dictionary-label>:</label>
        </td>
        <td class="bold">{{name}}</td>
      </tr>
      <tr>
        <td class="label"><label>
            <sc-dictionary-label
              dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.firstname"></sc-dictionary-label>:</label>
        </td>
        <td class="bold">{{firstname}}</td>
      </tr>
    </table>
    <ng-container *ngIf="hasSummaryHints()">
      <sc-content-spacer vertical></sc-content-spacer>
      <div class="hint">
        <sc-dictionary-label
          dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.hints"></sc-dictionary-label>
      </div>
    </ng-container>
    <ng-container *ngFor="let infoText of informationTexts; let first = first">
      <sc-content-spacer vertical></sc-content-spacer>
      <div class="hint">
        <sc-padding>
          <sc-dictionary-label [dictionaryKey]="infoText"></sc-dictionary-label>
        </sc-padding>
      </div>
    </ng-container>
    <ng-container *ngIf="showHintForGrandAreaAccessByCar">
      <sc-content-spacer vertical></sc-content-spacer>
      <div class="hint">
        <sc-padding>
          <sc-dictionary-label [dictionaryKey]="accessByCarHintDictionaryKey"></sc-dictionary-label>
        </sc-padding>
      </div>
    </ng-container>
  </mat-card>

  <h1
    *ngIf="this.translationService.translationExists('tmc-yard.widgets.registration-terminal.visitor-registration-summary.info', this.translationService.language)">
    <sc-dictionary-label
      dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.info"></sc-dictionary-label>
  </h1>

  <div class="success">
    <sc-flex centered>
      <i class="fa-light fa-sharp fa-check-circle"></i>
    </sc-flex>
  </div>

  <p class="gatekeeper-hint" *ngIf="gatekeeperMandatory">
    <sc-dictionary-label
      dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.hint"></sc-dictionary-label>
  </p>
</div>
